import { NavigationState } from '../shared/types';
import { navigateTo } from '../case/actions';

const initialNavigationState: NavigationState = {
    destination: '',
  };
  
  const navigationReducer = (state = initialNavigationState, action: any): NavigationState => {
    switch (action.type) {
      case navigateTo.type:
        return { ...state, destination: action.payload };
      default:
        return state;
    }
  };
  
  export default navigationReducer;
  